/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK SPACESEXTN Adaptor
 * Functions for calling AUTHEXTN API.
 ************************************************************/

var q = require('q');
var request = require('superagent');
var Agent = require('agentkeepalive');

var helpers = require('../../helpers');
var DLSError = helpers.errors.DLSError;

/*********************************
 * Setting Up Module Entry Point
 **********************************/
module.exports = spacesextn;

var keepaliveAgent = new Agent({
  timeout: 60000,
  freeSocketTimeout: 30000
});

//AuthExtn Adaptor Contsructor
function spacesextn(accountId) {
  this.accountId = accountId;
  return {
    entitleBulkUsersToProducts: entitleBulkUsersToProducts.bind(this),
    setupUser: setupUser.bind(this)
  };
}

/**
 * @param {
 *   *users: [{
 *      *ext_user_id: 'string',
 *      ext_role: 'string',
 *      *products: [{
 *        *productcode: 'string',
 *        ext_entitlement_meta: {
 *          start_date: <epoch>,
 *          *end_date: <epoch>
 *        },
 *        ext_data : {},
 *        *action: 'string'
 *      }]
 *   }],
 *   *ext_actor_id: 'string'
 * } options
 */
function entitleBulkUsersToProducts(options) {
  var self = this;
  // Initializing promise
  var dfd = q.defer();

  if (options && options.users && options.ext_actor_id) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTHEXTN +
      self.config.AUTHEXTN_API_URLS.entitleBulkUsersToProducts;
    url = helpers.api.constructAPIUrl(url, { accountid : self.accountId });

    // Setup request with URL and Params
    var requestAPI = request.post(url)
                    .set('Content-Type', 'application/json')
                    .set('Accept', 'application/json')
                    .send(options);

    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if(error) {
          var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
      });
  } else {
    var err = {};
    err.description = 'Mandatory params: \'users\', \'ext_actor_id\' not found in request options.';
    err.message = err.description;
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }

  return dfd.promise;
}

/**
 * @param {
 *  *ext_user_id: "string",
 *  *workflow_type: "string",
 *  *<workflow_type>: {}
 * } options
 */
function setupUser(options) {
  var self = this;
  //Initializing promise
  var deferred = q.defer();

  if (options && options.ext_user_id && options.workflow_type) {
    //Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.AUTHEXTN + self.config.AUTHEXTN_API_URLS.setupUser;
    url = helpers.api.constructAPIUrl(url, { accountId: self.accountId });

    var requestAPI = request.post(url)
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .send(options);

    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
    .agent(keepaliveAgent)
    .end(function(err, res) {
      if (err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        deferred.reject(err);
      } else {
        deferred.resolve(res.body);
      }
    });
  } else {
    var err = {};
    err.message = err.description = 'Mandatory field \'ext_user_id\' or \'workflow_type\' not found '+
      'in the request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    deferred.reject(err);
  }
  return deferred.promise;
}
